[
  {
    "id": "SWW-B7P-L202-001",
    "module": "SpellingWW",
    "difficulty": 202,
    "difficultyTier": 8,
    "levelCode": "B7+",
    "group": 7,
    "question": "Hij ... zijn sleutel kwijt. (raken)",
    "options": ["raakt", "raak", "raakte", "geraakt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "tt_hij",
    "familyId": "SWW-TT-HIJ-RAKEN",
    "conceptId": "tt_hij_stam_plus_t",
    "variantIndex": 1,
    "explanation": "Onderwerp is 'hij', dus tegenwoordige tijd is stam + t. Stam van 'raken' is 'raak'. Raak + t = raakt.",
    "distractorExplanations": {
      "1": "Dit is de ik-vorm: ik raak. Bij 'hij' hoort een t: raakt.",
      "2": "Dit is verleden tijd. Er staat geen tijdwoord dat naar gisteren wijst.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'is/heeft': hij is geraakt."
    }
  },
  {
    "id": "SWW-B7P-L202-002",
    "module": "SpellingWW",
    "difficulty": 202,
    "difficultyTier": 8,
    "levelCode": "B7+",
    "group": 7,
    "question": "Gisteren ... hij het raam. (breken)",
    "options": ["brak", "breekt", "gebroken", "braken"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_sterk",
    "familyId": "SWW-VT-STERK-BREKEN",
    "conceptId": "vt_sterk_enkelvoud",
    "variantIndex": 1,
    "explanation": "Door 'gisteren' kies je verleden tijd. 'Breken' is een sterk werkwoord. Enkelvoud verleden tijd is: brak.",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd. 'Gisteren' vraagt verleden tijd.",
      "2": "Dit is het voltooid deelwoord. Dat gebruik je met 'heeft': hij heeft gebroken.",
      "3": "Dit is verleden tijd meervoud (wij braken). Hier is het enkelvoud: hij brak."
    }
  },
  {
    "id": "SWW-B7P-L202-003",
    "module": "SpellingWW",
    "difficulty": 202,
    "difficultyTier": 8,
    "levelCode": "B7+",
    "group": 7,
    "question": "De fietsen zijn ... (repareren).",
    "options": ["gerepareerd", "gerepareerde", "repareerden", "gereparerd"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_geen_kofschip",
    "familyId": "SWW-VD-REPAREREN",
    "conceptId": "vd_zwak_geen_kofschip",
    "variantIndex": 1,
    "explanation": "Na 'zijn' gebruik je een voltooid deelwoord. Repareren → gerepareerd (eindigt niet op een 't kofschip-letter, dus -d).",
    "distractorExplanations": {
      "1": "Dit is de bijvoeglijke vorm met -e. Na 'zijn' gebruik je het voltooid deelwoord zonder -e.",
      "2": "Dit is verleden tijd meervoud. Na 'zijn' hoort een voltooid deelwoord.",
      "3": "Hier mist een letter. De juiste spelling is gerepareerd."
    }
  },
  {
    "id": "SWW-B7P-L202-004",
    "module": "SpellingWW",
    "difficulty": 202,
    "difficultyTier": 8,
    "levelCode": "B7+",
    "group": 7,
    "question": "Het boek wordt ... door de juf. (lezen)",
    "options": ["gelezen", "leest", "geleest", "las"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_sterk",
    "familyId": "SWW-LIJDENDE-VORM-LEZEN",
    "conceptId": "passief_wordt_vd",
    "variantIndex": 1,
    "explanation": "Dit is een lijdende vorm: wordt + voltooid deelwoord. Van 'lezen' is het voltooid deelwoord: gelezen.",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd en past niet na 'wordt'.",
      "2": "Dit is geen juiste spelling. Het voltooid deelwoord is gelezen.",
      "3": "Dit is verleden tijd. Door 'wordt' weet je dat je een voltooid deelwoord nodig hebt."
    }
  },
  {
    "id": "SWW-B7P-L202-005",
    "module": "SpellingWW",
    "difficulty": 202,
    "difficultyTier": 8,
    "levelCode": "B7+",
    "group": 7,
    "question": "Gisteren ... hij zijn kamer. (stoffen)",
    "options": ["stofte", "stofde", "stoft", "gestoft"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_kofschip",
    "familyId": "SWW-VT-KOFSCHIP-STOFFEN",
    "conceptId": "vt_zwak_kofschip_te",
    "variantIndex": 1,
    "explanation": "Door 'gisteren' kies je verleden tijd. Stam is 'stof'. De f zit in 't kofschip, dus je gebruikt -te: stofte.",
    "distractorExplanations": {
      "1": "Je kiest -de, maar f zit in 't kofschip. Daarom is het -te: stofte.",
      "2": "Dit is tegenwoordige tijd. Door 'gisteren' moet het verleden tijd zijn.",
      "3": "Dit is het voltooid deelwoord en hoort bij 'heeft': hij heeft gestoft."
    }
  }
]
